import React from 'react';
import PropTypes from 'prop-types';

import { StyledTextFieldContainer, StyledTextField } from '../../../../../components/Inputs';
import InputLabel from '../../../../../components/v2/InputLabel';

const CoachInfoFormField = ({
  label,
  value,
  onChange,
  placeholder,
  multiline,
  rows,
}) => (
  <StyledTextFieldContainer>
    <InputLabel>{label}</InputLabel>
    <StyledTextField
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      multiline={multiline}
      rows={multiline ? rows : undefined}
    />
  </StyledTextFieldContainer>
);

CoachInfoFormField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
};

CoachInfoFormField.defaultProps = {
  value: '',
  placeholder: '',
  multiline: false,
  rows: 4,
};

export default CoachInfoFormField;
